export default [
    {
        value: "DesenvolvimentoFerramenta",
        text: "Desenvolvimento de ferramenta"
    },
    {
        value: "ProspeccaoTecnologica",
        text: "Prospecção Tecnológica"
    },
    {
        value: "Outros",
        text: "Outros"
    }
]